<div class="flex flex-col gap-[10px] justify-start items-start">
  <div class="title flex flex-row">
    <vi-title asThirdTitle="true">{{
      '+INSTALLATIONS.INSTALLATION.HEATING_CIRCUIT_OVERLAY.TEMPERATURE_SELECTORS.TITLE' | translate
    }}</vi-title>
  </div>
  <div data-at-programs class="programs w-full min-w-full h-full min-h-full">
    <ng-container *ngFor="let mode$ of heatingPanelService.modes">
      <ng-container *ngIf="mode$ | async | ready as mode">
        <app-temperature-select
          *ngIf="mode | executable: 'setTemperature'"
          [isTile]="true"
          id="tile-program-select-{{ mode.feature | modeName }}"
          [title]="mode.feature | modeName | translateOperatingProgram"
          [rangeDefinition]="mode | constraints: 'setTemperature':'targetTemperature'"
          [value]="mode.properties?.temperature?.value"
          (valueChange)="heatingPanelService.onProgramTemperatureChange($event, mode.feature)"
        >
        </app-temperature-select>
      </ng-container>
    </ng-container>
    <!-- Eco mode temperature -->
    <ng-container *ngIf="!(heatingPanelService.isEcoMode$ | async)">
      <ng-container *ngIf="eco$ | async | ready as feature">
        <app-temperature-select
          *ngIf="feature | executable: 'setTemperature'"
          [isTile]="true"
          id="program-eco-mode-select--{{ feature.feature | modeName }}"
          [title]="feature.feature | modeName | translateOperatingProgram"
          [rangeDefinition]="feature | constraints: 'setTemperature':'targetTemperature'"
          [value]="feature?.properties?.temperature?.value"
          (valueChange)="heatingPanelService.onProgramTemperatureChange($event, feature.feature)"
        >
        </app-temperature-select>
      </ng-container>
    </ng-container>
    <!-- Comfort mode temperature -->
    <ng-container *ngIf="!(heatingPanelService.isComfortMode$ | async)">
      <ng-container *ngIf="comfort$ | async | ready as feature">
        <app-temperature-select
          *ngIf="feature | executable: 'setTemperature'"
          [isTile]="true"
          id="program-comfort-mode-select-{{ feature.feature | modeName }}"
          [title]="feature.feature | modeName | translateOperatingProgram"
          [rangeDefinition]="feature | constraints: 'setTemperature':'targetTemperature'"
          [value]="feature?.properties?.temperature?.value"
          (valueChange)="heatingPanelService.onProgramTemperatureChange($event, feature.feature)"
        >
        </app-temperature-select>
      </ng-container>
    </ng-container>
    <!-- Reduced/Normal/Comfort heating -->
    <ng-container *ngIf="reducedHeating$ | async | ready as feature">
      <app-temperature-select
        *ngIf="feature | executable: 'setTemperature'"
        [isTile]="true"
        id="cooling-reduced-mode-select-{{ feature.feature | modeName }}"
        [title]="feature.feature | modeName | translateOperatingProgram"
        [rangeDefinition]="feature | constraints: 'setTemperature':'targetTemperature'"
        [value]="feature?.properties?.temperature?.value"
        (valueChange)="heatingPanelService.onProgramTemperatureChange($event, feature.feature)"
      >
      </app-temperature-select>
    </ng-container>
    <ng-container *ngIf="normalHeating$ | async | ready as feature">
      <app-temperature-select
        *ngIf="feature | executable: 'setTemperature'"
        [isTile]="true"
        id="cooling-normal-mode-select-{{ feature.feature | modeName }}"
        [title]="feature.feature | modeName | translateOperatingProgram"
        [rangeDefinition]="feature | constraints: 'setTemperature':'targetTemperature'"
        [value]="feature?.properties?.temperature?.value"
        (valueChange)="heatingPanelService.onProgramTemperatureChange($event, feature.feature)"
      >
      </app-temperature-select>
    </ng-container>
    <ng-container *ngIf="comfortHeating$ | async | ready as feature">
      <app-temperature-select
        *ngIf="feature | executable: 'setTemperature'"
        [isTile]="true"
        id="cooling-comfort-mode-select-{{ feature.feature | modeName }}"
        [title]="feature.feature | modeName | translateOperatingProgram"
        [rangeDefinition]="feature | constraints: 'setTemperature':'targetTemperature'"
        [value]="feature?.properties?.temperature?.value"
        (valueChange)="heatingPanelService.onProgramTemperatureChange($event, feature.feature)"
      >
      </app-temperature-select>
    </ng-container>
  </div>
</div>
